<template>
  <div class="row">
    <div class="card col-xl-8 col-xxl-12">
      <div class="card-header">
        <b-form-group
          class="mb-0"
          :description="$t('auction.enter_title')"
        >
          <b-input
            v-model="auctionName"
            size="lg"
            :placeholder="$t('auction.new')"
          />
        </b-form-group>
      </div>
      <div class="card-body">
        <a-steps
          class="mb-3"
          :current="current"
          progress-dot
        >
          <a-step
            v-for="item in steps"
            :key="item"
            :description="item"
          />
        </a-steps>
        <SelectAuctions
          v-if="current === 0"
          v-model="selectedAuctions"
          :auction-types="auctionTypes"
        />
        <SelectSections
          v-else-if="current === 1"
          v-model="auctionCategories"
          :categories="categories"
        />
        <CommonAuctionSetup
          v-else-if="current === 2"
          v-model="auctionSettings"
        />
        <div class="steps-action">
          <a-button
            v-if="current < steps.length - 1"
            type="primary"
            :disabled="isNextDisabled"
            @click="next"
          >
            {{ $t('common.next') }}
          </a-button>
          <a-button
            v-if="current === steps.length - 1"
            type="primary"
            :disabled="isNextDisabled"
            @click="handleCreate"
          >
            {{ $t('auction.create') }}
          </a-button>
          <a-button
            v-if="current > 0"
            style="margin-left: 8px"
            @click="prev"
          >
            {{ $t('common.back') }}
          </a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auctionService from '@/services/api/admin/auction-service'

import SelectAuctions from './SelectAuctions'
import CommonAuctionSetup from './CommonAuctionSetup'
import SelectSections from './SelectSections'
export default {
  name: 'NewAuction',
  components: {
    SelectAuctions,
    CommonAuctionSetup,
    SelectSections,
  },

  props: {
    categories: {
      type: Array,
      default() {
        return []
      },
    },
  },

  data() {
    return {
      current: 0,
      steps: [this.$t('auction.select_lot_types'), this.$t('auction.select_sections'), this.$t('auction.common_setup')],
      auctionName: '',
      auctionSettings: {
        prizeExpiry: null,
        activeFrom: null,
        activeTo: null,
        startPrice: null,
        minFinalPrice: null,
        minBidStep: null,
        isFormValid: false,
      },

      auctionCategories: [],

      auctionTypes: [
        {
          title: this.$t('auction.lot_types.main'),
          value: 'MAIN',
          capacity: 12,
        },
        {
          title: this.$t('auction.lot_types.search'),
          value: 'SEARCH',
          capacity: 12,
        },
        {
          title: this.$t('auction.lot_types.category'),
          value: 'CATEGORY',
          capacity: 12,
        },
      ],
      selectedAuctions: [],
    }
  },

  computed: {
    currentTitle() {
      return this.selectedAuctions[this.current - 2] || null
    },

    isLotSelectValid() {
      return (this.selectedAuctions.length > 0 &&
        this.selectedAuctions.reduce((res, auction) => {
          return res && auction.places > 0
        }, true))
    },

    isNextDisabled() {
      switch (this.current) {
        case 0:
          return !this.isLotSelectValid
        case 1:
          return this.auctionCategories.length === 0
        case 2:
          return !this.auctionSettings.isFormValid || this.auctionName.length <= 3
        default:
          return false
      }
    },
  },

  mounted() {
    this.fetchQuotes()
  },

  methods: {
    next() {
      this.current++
    },
    prev() {
      this.current--
    },

    async fetchQuotes() {
      try {
        const res = await auctionService.getQuotes()
        const quotes = res.data.content
        quotes.forEach(quote => {
          const type = this.auctionTypes.find(elem => elem.value === quote.type)
          type.capacity = quote.count
        })
      } catch (error) {
        console.log(error)
      }
    },

    handleCreate() {
      const payload = {
        auction_name: this.auctionName,
        active_from: this.auctionSettings.activeFrom,
        active_to: this.auctionSettings.activeTo,
        status: 'NEW',
        auctionSettings: {
          minFinishPrice: this.auctionSettings.minFinalPrice,
          startPrice: this.auctionSettings.startPrice,
          minimumStep: this.auctionSettings.minBidStep,
          ttl: this.auctionSettings.prizeExpiry,
        },
        auctionSubCategories: this.auctionCategories,
        lotPromotion: this.selectedAuctions,
      }

      this.$emit('create', payload)
    },
  },
}
</script>

<style scoped>
  .date-divider {
    height: 100%;
  }
</style>
